import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Icon from './Icon';
import Path from './Path';
var STATUS_VARIANTS = {
  confirmed: {
    iconColor: 'success',
    iconFilled: 'general.checkCircle',
    iconOutlined: 'general.outlinedCircleCheck'
  },
  unconfirmed: {
    iconColor: 'warning',
    iconFilled: 'general.questionCircle',
    iconOutlined: 'general.outlinedQuestionCircle'
  },
  declined: {
    iconColor: 'error',
    iconFilled: 'general.xCircle',
    iconOutlined: 'general.outlinedXCircle'
  }
};

function Status(props) {
  var color = props.color,
      variant = props.variant,
      variantFilled = props.variantFilled,
      restProps = _objectWithoutPropertiesLoose(props, ["color", "variant", "variantFilled"]);

  var _STATUS_VARIANTS$vari = STATUS_VARIANTS[variant],
      iconOutlined = _STATUS_VARIANTS$vari.iconOutlined,
      iconFilled = _STATUS_VARIANTS$vari.iconFilled,
      iconColor = _STATUS_VARIANTS$vari.iconColor;
  var variantColor = color || iconColor;
  var variantIcon = variantFilled ? iconFilled : iconOutlined;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    name: variantIcon,
    color: variantColor
  }, restProps), /*#__PURE__*/React.createElement(Path, {
    name: "tapestry.radio0",
    color: color
  }));
}

Status.displayName = 'Icon.Status';
export default Status;